import {
  Directive,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
  inject,
  input,
} from '@angular/core';

/**
 * Adds a class to the host when it enters the viewport (Intersection Observer).
 * Use for scroll-triggered animations (e.g. fade-in, slide-up on usecase cards).
 */
@Directive({
  selector: '[appInView]',
  standalone: true,
})
export class InViewDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);

  /** Class to add when in view (default: 'in-view'). */
  inViewClass = input<string>('in-view');

  /** Root margin for observer (default: '0px 0px -10% 0px' so trigger when 10% visible). */
  rootMargin = input<string>('0px 0px -10% 0px');

  /** Threshold 0–1 (default: 0 = any visibility). */
  threshold = input<number>(0);

  private observer: IntersectionObserver | null = null;

  ngOnInit(): void {
    const rootMargin = this.rootMargin();
    const threshold = this.threshold();
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const cls = this.inViewClass();
          if (entry.isIntersecting) {
            this.renderer.addClass(entry.target, cls);
          } else {
            this.renderer.removeClass(entry.target, cls);
          }
        }
      },
      { rootMargin, threshold }
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
